import React, { useEffect, useState } from "react";
import { Select, Form } from "antd";

export interface YearSelectProps {
	label?: string | boolean,
	name?: string,
	styles?: React.CSSProperties,
	showAll?: boolean,
	placeholder?: string,
	rules?: any,
	onSelect?: (value: number) => void;
}

const { Option } = Select;
const YearSelect: React.FC<YearSelectProps> = (props) => {
	const { label, name, styles, showAll, placeholder, rules, onSelect } = props;

	const onSelectHandle = (value: number) => {
		onSelect && onSelect(value)
	}
	
	return (
		<Form.Item 
			label={label} 
			name={name} 
			style={{...styles}}
			rules={rules}
		>
			<Select placeholder={placeholder} onSelect={onSelectHandle}>
				{ showAll && <Option value="all">全部</Option> }
				<Option value={2022}>2022</Option>
                <Option value={2023}>2023</Option>
                <Option value={2024}>2024</Option>
			</Select>
		</Form.Item>
  )
}

YearSelect.defaultProps = {
	label: '年度',
	name: 'subject',
	showAll: false,
	placeholder: '请选择'
}

export default YearSelect;